import type { ConfigApi } from "@backstage/core-plugin-api";

/** Activa App Proxy si está habilitado y el origin actual coincide con app.baseUrl. */
export function isAppProxyActive(
  configApi: ConfigApi,
  origin: string,
): boolean {
  const appOrigin = new URL(configApi.getString("app.baseUrl")).origin;
  return (
    configApi.getOptionalBoolean("app.oauth2ProxyEnabled") === true &&
    appOrigin === origin
  );
}
